import React, { Component } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FormattedMessage } from "react-intl";

class ConfirmDialog extends Component {
  state = { isProcessing: false };

  componentDidUpdate(prevProps) {
    // Reset disabled state whenever the modal opens/closes so a failed
    // proceed leaves the dialog usable next time it's opened.
    if (prevProps.isOpen !== this.props.isOpen) {
      this.setState({ isProcessing: false });
    }
  }

  handleProceed = () => {
    this.setState({ isProcessing: true });
    this.props.onProceed();
  };

  render() {
    return (
      <Modal size="md" isOpen={this.props.isOpen} toggle={this.props.toggle}>
        <ModalHeader toggle={this.props.toggle}>{this.props.title}</ModalHeader>
        <ModalBody>{this.props.message}</ModalBody>
        <ModalFooter>
          <Button outline color="secondary" onClick={this.props.toggle}>
            <FormattedMessage id={this.props.cancelKey || "Cancel"} />
          </Button>
          <Button
            onClick={this.handleProceed}
            color={this.props.danger ? "danger" : "primary"}
            outline
            disabled={this.state.isProcessing}
          >
            <FormattedMessage id={this.props.proceedKey || "Continue"} />
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default ConfirmDialog;
